import qs from 'qs';
import moment from 'moment';

export default function(Vue) {
    return {
        init({commit}) {
            let promiseArr = [Vue.axios.get('/init'), Vue.axios.get('/sites')];
                return Promise.all(promiseArr).then(results => {
                    let sites = results[1].data.sites;
                    let data = results[0].data;
                    commit('SET_TOP_LEVEL_TAGS', data.topLevelTags);
                    commit('SET_SITES', sites);
                    commit('SET_PAYMENT_METHODS', data.paymentMethods);
                    commit('SET_SITE_GROUPS', data.siteGroups);
                    commit('SET_UNSUITABLENESS', data.nonconformances);
                    commit('SET_DATA_TYPES', data.dataTypes);
                    commit('SET_SOURCE_TYPES', data.sourceTypes);
                    commit('SET_USER', data.user);
                    commit('SET_LOCALE', data.user.language);
                    commit('SET_FORM_TYPES', data.formTypes);
                    commit('SET_UNITS', data.units);
                    commit('SET_SITE_TYPES', data.siteTypes);
                    commit('SET_DASHBOARD_DATA_TYPES', data.dashboardDataTypes);
                    commit('SET_ANALYSIS_UNIT', data.analysisUnit);
                    commit('SET_USERS', data.users);
                    commit('SET_SITES_WITH_GROUPS');
                    commit('SET_AWS_OPTIONS', data.isExcludedForAws);
                    this.dispatch('getLocations');
                    this.dispatch('getRelationalTags');
                    //commit('SET_ADMIN_LIST', data.agentList);
                    return true;
                });
        },
        getDocumentCounts({commit, state}, startDate = null) {
            let query = qs.stringify(
                {
                    max_updated_at: state.maxUpdatedAtForDocuments,
                    start_date: startDate
                },
                {
                    skipNulls: true
                }
            );
            return Vue.axios.get(`/documents/?${query}`).then(({data}) => {
                if (data.updateValue) {
                    commit('SET_DOCUMENTS', data.counts);
                    commit('SET_MAX_UPDATED_AT_FOR_DOCUMENTS', data.maxUpdatedAt);
                }
                return true;
            });
        },
        getGoalCounts({commit, state}) {
            let query = qs.stringify(
                {
                    max_updated_at: state.maxUpdatedAtForGoals
                },
                {
                    skipNulls: true
                }
            );
            return Vue.axios.get(`/goals?${query}`).then(({data}) => {
                if (data.updateValue) {
                    commit('SET_GOALS', data.counts);
                    commit('SET_MAX_UPDATED_AT_FOR_GOALS', data.maxUpdatedAt);
                }
                return true;
            });
        },
        getUsers({commit}){
            return Vue.axios.get('/getAllUsers').then(({data})=>{
                commit('SET_USERS', data);
                return true
            })
        },
        getAuditCounts({commit, state}, startDate = null) {
            let query = qs.stringify(
                {
                    updatedAt: state.maxUpdatedAtForAudits,
                    start_date: startDate
                },
                {
                    skipNulls: true
                }
            );
            return Vue.axios.get(`/audits?${query}`).then(({data}) => {
                if (data.updateValue) {
                    commit('SET_AUDITS', data.report);
                    commit('SET_MAX_UPDATED_AT_FOR_AUDIT', data.maxUpdatedAt);
                }
                return true;
            });
        },
        getTicketListBySiteID({commit, state}, siteId, startDate = moment().year()) {
            let query = qs.stringify({start_date: startDate});
            if (siteId) {
                return Vue.axios
                    .get(`${siteId}/audits?${query}`)
                    .then(({data}) => {
                        commit('SET_TICKET_LIST', data);
                        return true;
                    })
                    .catch(err => {
                        commit('SET_TICKET_LIST', []);
                        return Promise.reject(err);
                    });
            } else {
                commit('SET_TICKET_LIST', []);
                return Promise.reject('missing siteId');
            }
        },
        getDataTypes({commit}){
            return Vue.axios
                .get('/getDataTypes')
                .then(({data}) => {
                    commit('SET_DATA_TYPES', data);
                });
        },
        getLocations({commit}){
            return Vue.axios
                .get('/getAllLocationsAndSectors')
                .then(({data}) => {
                    commit('SET_LOCATIONS_AND_SECTORS', data);
                });
        },
        getRelationalTags({commit}){
            return Vue.axios
                .get('/getRelationalTags')
                .then(({data}) => {
                    commit('SET_RELATIONAL_TAGS', data);
                });
        },
        getSites({commit}){
            return Vue.axios
                .get('/sites')
                .then(({data}) => {
                    commit('SET_SITES', data.sites);
                });
        },
    };
}



// WEBPACK FOOTER //
// ./src/store/actions.js